import { render } from "./DeliveriesList.vue?vue&type=template&id=13b381f5"
import script from "./DeliveriesList.vue?vue&type=script&lang=js"
export * from "./DeliveriesList.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/hi5admin_demo/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__